// extracted by mini-css-extract-plugin
export default {"card":"styles_card__AA1sW","cardTitle":"styles_cardTitle__GSdfw"};